export function translateMenuItems(items: any[], t: any): any[] {
	return items.map((item) => {
		const translatedItem = translateMenuItem(item, t);

		if (item.items && Array.isArray(item.items)) {
			translatedItem.items = translateMenuItems(item.items, t);
		}

		return translatedItem;
	});
}

export function translateMenuItem(item: any, t: any): any {
	if (item.text) {
		switch (item.text) {
			case "Sort Ascending":
				return { ...item, text: t("sort-ascending") };
			case "Sort Descending":
				return { ...item, text: t("sort-descending") };
			case "Clear Sorting":
				return { ...item, text: t("clear-sorting") };
			case "Set Fixed Position":
				return { ...item, text: t("set-fixed-position") };
			case "Left":
				return { ...item, text: t("left") };
			case "Right":
				return { ...item, text: t("right") };
			case "Unfix":
				return { ...item, text: t("unfix") };
			default:
				return item;
		}
	}

	if (item.icon) {
		switch (item.icon) {
			case "context-menu-sort-asc":
				return { ...item, text: t("sort-ascending") };
			case "context-menu-sort-desc":
				return { ...item, text: t("sort-descending") };
			case "context-menu-sort-none":
				return { ...item, text: t("clear-sorting") };
			case "fix-column":
				return { ...item, text: t("set-fixed-position") };
			case "fix-column-left":
				return { ...item, text: t("left") };
			case "fix-column-right":
				return { ...item, text: t("right") };
			case "unfix-column":
				return { ...item, text: t("unfix") };
			default:
				return item;
		}
	}

	return item;
}
